/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Accounts_TitleInputs */

const en_mk_tb_accounts_title = /** @type {(inputs: Mk_Tb_Accounts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep personal accounts personal`)
};

const id_mk_tb_accounts_title = /** @type {(inputs: Mk_Tb_Accounts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun pribadi tetap milik masing-masing`)
};

/**
* | output |
* | --- |
* | "Keep personal accounts personal" |
*
* @param {Mk_Tb_Accounts_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_accounts_title = /** @type {((inputs?: Mk_Tb_Accounts_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Accounts_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_accounts_title(inputs)
	return en_mk_tb_accounts_title(inputs)
});